module.exports = __webpack_public_path__ + "static/eth_code-eb6e7df64150b7ceb2f4b46668ebce76.png";